import { CardInfoBox } from "./CardInfoBox";

export default CardInfoBox;
